import React from "react"
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedHTMLMessage, FormattedMessage} from "react-intl";
import {loadDashboard} from "../../actions/actions";
import Loading from "../../../../common/js/components/loading";
import images from "../../../../common/images/dashboard";
import ContentUnitListItem from "../content-unit/list-item";
import ProgressWithIcon from "../../../../common/js/components/progress-with-icon";
import ProgressWithoutIcon from "../../../../common/js/components/progress-without-icon";
import Notifications from "../../../../common/js/notifications/components/notifications";
import ReactPlayer from "react-player";
import Contact from "../../../../common/js/components/dashboard/contact";
import CategoryCard from "../../../../common/js/components/dashboard/category-card";
import BadgesCandidate from "../../../../common/js/components/badges/badges-candidate";

class Dashboard extends React.Component {

    componentWillMount() {
        this.props.loadDashboard('api/v1/candidate_accounts');
    }

    render() {
        let dashboard = this.props.dashboard.data;

        if (!dashboard)
            return (<Loading main={true} mainClassName={'bg-gray'}/>);

        const mainVideoConfig = {
            file: {
                attributes: {
                    controlsList: 'nodownload'
                }
            }
        };

        let mainVideoSource, mainVideoPoster;
        if ( dashboard.assets && dashboard.assets['main_video'] && dashboard.assets['main_video_poster'] ) {
            mainVideoSource = dashboard.assets['main_video']['url'];
            mainVideoPoster = dashboard.assets['main_video_poster']['url'];
        }

        return (
            <div className='main-content bg-gray'>
                <Notifications container={true} app='candidate'/>
                <section>
                    <div className='container pt-5 pb-3'>
                        <div className='row'>
                            <div className='col-md-7 col-xl-8 pb-3'>
                                <hr className='gasnet-divider'/>
                                <FormattedMessage id='app.dashboard.welcome' values={{name: dashboard.greeting}}>{(txt) => (<h1 className='mb-3'>{txt}</h1>)}</FormattedMessage>
                                <FormattedMessage id='app.dashboard.welcome_text'/>
                            </div>
                            {
                            dashboard.days_remaining > 0 &&
                            <div className='col-md-5 col-xl-4'>
                                <div className='card bg-gray calendar-card mb-4'>
                                    <div className='card-body'>
                                        <div className='text-center'>
                                            <img src={images.dashboard.calendar} className='calendar-card__image'/>
                                        </div>
                                        <FormattedHTMLMessage id='app.dashboard.days_remaining' values={{days: dashboard.days_remaining}}/>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        { dashboard.next_step &&
                        <div id='next-step' className='pt-3'>
                            <FormattedMessage id='app.dashboard.what_should_be_next_step'>{(txt) => (<h2 className='mb-4'>{txt}</h2>)}</FormattedMessage>
                            <ContentUnitListItem assignment={dashboard.next_step} color='gasnet-green content-green'/>
                        </div>
                        }
                    </div>
                </section>
                <section className='bg-gray'>
                    <div className='container pt-4 pb-4'>
                        <ProgressWithoutIcon progress={{value: (dashboard.important_documents_progress + dashboard.life_at_innogy_progress), max: 2}}/>
                    </div>
                </section>
                <section className='pt-5 pa-bottom'>
                    <div className='container'>
                        <FormattedMessage id='app.dashboard.all_needed_info'>{(txt) => (<h2 className='mb-4'>{txt}</h2>)}</FormattedMessage>
                        <div className='card-deck overview-cards'>
                            <CategoryCard progress={dashboard.important_documents_progress} category='important_documents' id='important-documents'/>
                            <CategoryCard progress={dashboard.life_at_innogy_progress} category='life_at_innogy' id='life-at-innogy'/>
                        </div>
                    </div>
                </section>
                <section className='bg-white pa-top'>
                    <div className='container'>
                        <FormattedMessage id='app.dashboard.trophies'>{(txt) => (<h2 className='mb-4'>{txt}</h2>)}</FormattedMessage>
                        <BadgesCandidate progress_states={dashboard.progress_states}/>
                    </div>
                </section>
                <section className='bg-white pa'>
                    <div className='container'>
                        <FormattedMessage id='app.dashboard.useful_info'>{(txt) => (<h2 className='mb-4'>{txt}</h2>)}</FormattedMessage>
                        <div className='row'>
                            { dashboard.recruiter && <Contact data={dashboard.recruiter} relation='recruiter'/> }
                            { dashboard.manager && <Contact data={dashboard.manager} relation='manager'/> }
                        </div>
                    </div>
                </section>
                {/*<section className='bg-pink pa'>*/}
                {/*    <div className='container'>*/}
                {/*        <div className='row'>*/}
                {/*            <div className='col-md-5'>*/}
                {/*                <FormattedMessage id='app.dashboard.how_this_process_will_look_like'>{(txt) => (<h2 className='mb-4'>{txt}</h2>)}</FormattedMessage>*/}
                {/*                <p><FormattedMessage id='app.dashboard.how_this_process_will_look_like_text'/></p>*/}
                {/*            </div>*/}
                {/*            <div className='col-md-7'>*/}
                {/*                <ReactPlayer className={'img-fluid'} url={mainVideoSource} controls={true} config={mainVideoConfig} fileConfig={{ attributes: { poster: mainVideoPoster } }}/>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</section>*/}
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        dashboard: state.dashboard
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        loadDashboard: loadDashboard
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Dashboard));
